export default __webpack_public_path__ + "static/media/lu.2c344846.svg";